import { DataAccess } from "../../../dataaccess/data.access";

export interface EngagementAnalyticsFilter {
    dateStart?: string;
    dateEnd?: string;
    bucket?: "day" | "week" | "month";
    organizationIds?: number[];
    categoryIds?: number[];
    eventIds?: number[];
    locationRoomIds?: number[];
    demographicCustAtrbIds?: number[];
    /** Omit attendance without a value for each selected demographic attribute. */
    excludeNone?: boolean;
    topN?: number;
    reportKey?: string;
}

export interface SummaryCards {
    activeOrganizations: number;
    attendedEvents: number;
    totalAttendees: number;
    uniqueAttendees: number;
    averageAttendees: number;
}

export interface TimelinePoint {
    bucket: string;
    total: number;
    unique: number;
}

export interface RankedItem {
    id?: number;
    name?: string;
    total: number;
    unique: number;
}

export interface CategorySlice {
    catId?: number;
    name?: string;
    total: number;
    unique: number;
}

export interface MembershipBreakdown {
    memberTotal: number;
    memberUnique: number;
    nonMemberTotal: number;
    nonMemberUnique: number;
}

export interface MembershipCountPoint {
    orgId?: number;
    orgName?: string;
    bucket: string;
    contCount: number;
}

export interface DemographicSlice {
    value: string;
    total: number;
    unique: number;
}

export interface DemographicBreakdown {
    custAtrbId?: number;
    name?: string;
    slices: DemographicSlice[];
}

export interface EngagementAnalyticsSummary {
    summary: SummaryCards;
    timeline: TimelinePoint[];
    topOrganizations: RankedItem[];
    topEvents: RankedItem[];
    topLocations: RankedItem[];
    categories: CategorySlice[];
    membershipOverTime: MembershipCountPoint[];
    membership: MembershipBreakdown;
    demographics: DemographicBreakdown[];
}

export interface ContactCustomAttributeDef {
    custAtrbId: number;
    custAtrbName: string;
    atrbDataType?: string;
}

export class SeAnalyticsService {
    static getSummary(filter: EngagementAnalyticsFilter): Promise<EngagementAnalyticsSummary> {
        return DataAccess.post<EngagementAnalyticsSummary>("/engagement/analytics/summary.json", filter);
    }

    /** Raw-row CSV for a report; returns the CSV text so the caller can trigger a browser download. */
    static exportCsv(filter: EngagementAnalyticsFilter): Promise<string> {
        return DataAccess.post<string>("/engagement/analytics/export.json", filter, { responseType: "text" });
    }
}
